import React, { useContext, useLayoutEffect, useState } from 'react';

import * as S from './styles';
import ScreensStaticContext from '../../../../context/ScreensStaticContext';
import { ScreenInovationType } from 'types/ScreenInovationType';

export default function BodyInovation() {
	const { screens } = useContext(ScreensStaticContext);

	const [inovationData, setInovationData] =
		useState<ScreenInovationType | null>(null);

	useLayoutEffect(() => {
		if (screens.length > 0) {
			const screen = screens.find((screen) => screen.type === 'inovation');
			if (screen) {
				setInovationData((screen.data as ScreenInovationType) || null);
			}
		}
	}, [screens]);

	return (
		<S.container>
			{inovationData ? (
				<>
					{inovationData.mainImgUrl !== '' ? (
						<S.imgRound>
							<img
								src={inovationData.mainImgUrl}
								alt={inovationData.mainImgUrl}
							/>
						</S.imgRound>
					) : (
						<S.dataNotSetting>
							<p>Configure a primeira imagem</p>
						</S.dataNotSetting>
					)}

					{inovationData.secondImgUrl !== '' ? (
						<S.imgRound>
							<img
								src={inovationData.secondImgUrl}
								alt={inovationData.secondImgUrl}
							/>
						</S.imgRound>
					) : (
						<S.dataNotSetting>
							<p>Configure a senguda imagem</p>
						</S.dataNotSetting>
					)}

					{inovationData.title !== '' ? (
						<S.title>{inovationData.title}</S.title>
					) : (
						<S.dataNotSetting>
							<p>Configure o título</p>
						</S.dataNotSetting>
					)}

					{inovationData.description !== '' ? (
						<S.description>{inovationData.description}</S.description>
					) : (
						<S.dataNotSetting>
							<p>Configure a descrição</p>
						</S.dataNotSetting>
					)}

					{inovationData.btn.textBtn !== '' ? (
						<S.btn>{inovationData.btn.textBtn}</S.btn>
					) : (
						<S.dataNotSetting>
							<p>Configure o botão</p>
						</S.dataNotSetting>
					)}

					{inovationData.lastImgUrl !== '' ? (
						<S.imgFull>
							{' '}
							<img
								src={inovationData.lastImgUrl}
								alt={inovationData.lastImgUrl}
							/>
						</S.imgFull>
					) : (
						<S.dataNotSetting>
							<p>Configure a ultima imagem</p>
						</S.dataNotSetting>
					)}
				</>
			) : (
				<S.notSetting>
					<p>Configure a tela de inovação</p>
				</S.notSetting>
			)}
		</S.container>
	);
}
